@if (canSeePrice) {
<div>
  <div class="row" style="text-align: right">
    <div class="col-12" style="text-align: right">
      @if (!isCustomer) {
      <p-button type="button" (click)="addPriceAdjustment()" [disabled]="!isEditable" severity="info"
        label="Price Adjustment"></p-button>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12 input-group">
      <label class="input-label">Subtotal&nbsp;&nbsp;</label>
      @if (workOrder) {
        <app-currency-input
          [name]="'subTotal'"
          [isRequired]="false" 
          [isDisabled]="true" 
          [value]="helper.subTotal(workOrder)"
        ></app-currency-input>
      }
    </div>
  </div>
  @if (workOrder) {
  @for (adj of workOrder.workOrderPriceAdjustments; track adj; let i = $index) {
  <div class="row">
    <div class="col-12 input-group">
      <p-button type="button" icon="pi pi-trash" (click)="deletePriceAdjustment(adj)"
        class="tableButtonMarginLeft" severity="danger" [disabled]="!isEditable">
      </p-button>&nbsp;&nbsp;
      <input pInputText [name]="'adjReason' + i" [(ngModel)]="adj.priceAdjustment.reason"
        placeholder="Adjustment Reason" [disabled]="!isEditable" required />&nbsp;&nbsp;
      <div style="display: inline-flex;">
        <p-inputgroup class="small-input">
          <p-inputnumber type="number" min="-100" max="100"  [name]="'adjPercentage' + i" [(ngModel)]="adj.priceAdjustment.percentage" [disabled]="!isEditable" required />
          <p-inputgroup-addon>%</p-inputgroup-addon>
        </p-inputgroup>
          &nbsp;&nbsp;
      </div>
      <app-currency-input
        [name]="'adjChange' + i"
        [isRequired]="false" 
        [isDisabled]="true" 
        [value]="helper.adjustmentAmount(adj, workOrder)"
      ></app-currency-input>
    </div>
  </div>
  }
  }
  @if (workOrder && workOrder.workOrderPriceAdjustments.length > 0) {
  <div class="row">
    <div class="col-12 input-group">
      <label class="input-label">Total After Price Adjustment&nbsp;&nbsp;</label>
      <app-currency-input
        [name]="'totalAfterAdjustment'"
        [isRequired]="false" 
        [isDisabled]="true" 
        [value]="helper.totalPriceAfterAdjustment(workOrder)"
      ></app-currency-input>
    </div>
  </div>
  }
  @if (helper.qualifiesForFirmtimeRefund(workOrder)) {
  <div class="row">
    <div class="col-12 input-group">
      <label class="input-label">Firm-Time Refund&nbsp;&nbsp;</label>
      @if (workOrder) {
      <app-currency-input
        [name]="'refund'"
        [isRequired]="false" 
        [isDisabled]="true" 
        [value]="100"
      ></app-currency-input>
      }
    </div>
  </div>
  }
  <div class="row">
    <div class="col-12 input-group">
      <label class="input-label">Sales Tax&nbsp;&nbsp;</label>
      <div style="display: inline-block;">
        <div class="totalBoxes">
          @if (workOrder) {
          <p-inputgroup class="small-input">
            <p-inputnumber type="number" min="0.0" max="100.0"  name="salesTaxPercentage" [(ngModel)]="workOrder.salesTaxPercentage" [disabled]="!isEditable || workOrder.customer.taxExempt" mode="decimal" [maxFractionDigits]="2"/>
            <p-inputgroup-addon>%</p-inputgroup-addon>
          </p-inputgroup>
          }
          &nbsp;&nbsp;
        </div>
      </div>
      @if (workOrder) {
      <app-currency-input
        [name]="'salesTax2'"
        [isRequired]="false" 
        [isDisabled]="true" 
        [value]="helper.salesTaxAmount(workOrder)"
      ></app-currency-input>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12 input-group">
      <label class="input-label">Total&nbsp;&nbsp;</label>
      @if (workOrder) {
      <app-currency-input
        [name]="'totalAmount'"
        [isRequired]="false" 
        [isDisabled]="true" 
        [value]="helper.totalAmount(workOrder)"
      ></app-currency-input>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12 input-group">
      <label class="input-label">Total Completed&nbsp;&nbsp;</label>
      @if (workOrder) {
      <app-currency-input
        [name]="'salesTax'"
        [isRequired]="false" 
        [isDisabled]="true" 
        [value]="helper.totalAmountCompleted(workOrder)"
      ></app-currency-input>
      }
    </div>
  </div>
  @for (cash of asWorkOrderNotQuote()?.workOrderCashCollected; track cash; let i = $index) {
  <div class="row">
    <div class="col-12 input-group">
      <label for="total" class="input-label"><span class="totalLabel">Value of Cash or Check Collected</span>&nbsp;&nbsp;</label>
      @if (workOrder) {
      <app-currency-input
        [name]="'cashCollected' + i"
        [isRequired]="true" 
        [isDisabled]="false" 
        [value]="asWorkOrderNotQuote().workOrderCashCollected[i].amount"
        (emitResult)="cashCollectedChange($event, i)"
      ></app-currency-input>
      }
      @if (!cash.id && isCashCollectedEditable()) {
      <p-button type="button" severity="danger" (click)="removeCashCollectedEntry(i)" icon="pi pi-trash"
        style="margin-left:4px">
      </p-button>
      }
    </div>
  </div>
  }
</div>
}